export enum UserListTabView {
  CurrentFolder = 'currentFolder',
  SubFolder = 'subFolder',
}
